import axios from 'axios';
import { useState } from 'react';
import { useNotificationStore } from '../../components/notificationStore';
import { useUserStore } from '../../components/userStore';

const Preferences = () => {
	const { user, updateUser } = useUserStore();
	const { showSuccess, showError } = useNotificationStore();
	const [isUpdating, setUpdating] = useState(false);

	const handleUpdatePreferences = async (updatedUser) => {
		setUpdating(true);
		try {
			await axios.patch(`/coords/${updatedUser.id}`, {
				email_notifications: updatedUser.email_notifications,
				text_notifications: updatedUser.text_notifications,
			});
			updateUser(updatedUser);
			showSuccess('Preferences updated successfully.');
		} catch (error) {
			showError('Failed to update preferences. Please try again.');
		} finally {
			setUpdating(false);
		}
	};

	return (
		<div className="container p-4 mx-auto preferences">
			<div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
				<div className="px-4 sm:px-0">
					<h2>Preferences</h2>
					<p className="mt-1 text-sm leading-6 text-gray-600">
						Manage your service request notification preferences.
					</p>
				</div>
				<form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
					<div className="card-body">
						<div>
							<div className="flex-row items-center gap-8 form-control">
								<label className="w-4/12 cursor-pointer label">
									<span className="label-text">Email notifications</span>
									<input
										type="checkbox"
										className="toggle toggle-primary"
										checked={user.email_notifications}
										disabled={isUpdating}
										onChange={({ target }) =>
											handleUpdatePreferences({
												...user,
												email_notifications: target.checked,
											})
										}
									/>
								</label>
								<span>{user.email_notifications ? 'On' : 'Off'}</span>
							</div>
							<div className="flex-row items-center gap-8 form-control">
								<label className="w-4/12 cursor-pointer label">
									<span className="label-text">Text notifications</span>
									<input
										type="checkbox"
										className="toggle toggle-primary"
										checked={user.text_notifications}
										disabled={isUpdating}
										onChange={({ target }) =>
											handleUpdatePreferences({
												...user,
												text_notifications: target.checked,
											})
										}
									/>
								</label>
								<span>{user.text_notifications ? 'On' : 'Off'}</span>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Preferences;
